import { useEffect, useState } from "react";
import { updateUserPayoutProvider, getAllUsersForProvoider } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import "./PayinModal.css";
import { toast } from "react-toastify";

export default function AddPayoutModal({ providerId, onClose, onSuccess }) {
  const token = useSelector((store) => store.userReducer.token);
  const [merchants, setMerchants] = useState([]);
  const [selectedMerchants, setSelectedMerchants] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getAllUsersForProvoider(token, 1, 2);
        console.log("Fetched Users:", res);
        if (res?.data) {
          const admins = res.data.filter((user) => user.role === "admin");
          setMerchants(admins);
        } else {
          setMerchants([]);
        }
      } catch (err) {
        console.error("Error fetching users:", err);
        setMerchants([]);
      }
    };
    fetchData();
  }, [token]);

  const toggleMerchant = (id) => {
    setSelectedMerchants((prev) =>
      prev.includes(id) ? prev.filter((m) => m !== id) : [...prev, id]
    );
  };

  const handleSave = async () => {
    try {
      const res = await updateUserPayoutProvider(providerId, selectedMerchants,token);
      console.log("Update Response:", res);
      toast.success(res.message || "Merchants updated successfully.");
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      toast.error(err.message || "Error saving merchants.");
      console.error("Error saving merchants:", err);
    }
  };

  // 🔎 Filter merchants
  const filteredMerchants = merchants.filter((m) => {
    const searchTerm = search.toLowerCase();
    const alias = m.alias?.toLowerCase() || "";
    const name = m.name?.toLowerCase() || "";

    // If merchant has alias → search only with alias
    // If no alias → search with merchant name
    if (alias) {
      return alias.includes(searchTerm);
    } else {
      return name.includes(searchTerm);
    }
  });

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h2 className="modal-title">Add Payout Merchants</h2>

        {/* 🔎 Search Box */}
        <input
          type="text"
          placeholder="Search merchants..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />

        <div className="modal-body">
          {filteredMerchants.length > 0 ? (
            filteredMerchants.map((m) => (
              <label key={m.id} className="merchant-item">
                <input
                  type="checkbox"
                  checked={selectedMerchants.includes(m.id)}
                  onChange={() => toggleMerchant(m.id)}
                />
                <span>{m.alias || m?.id}</span>
              </label>
            ))
          ) : (
            <p>No merchants found.</p>
          )}
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="btn btn-cancel">
            Cancel
          </button>
          <button onClick={handleSave} className="btn btn-save">
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
